import { FormFieldComponentProps } from './fieldProps';

const SliderField = ({ field, value, disabled, onChange, onBlur }: FormFieldComponentProps) => {
	const min = Number(field.settings.min ?? 0);
	const max = Number(field.settings.max ?? 100);
	const step = Number(field.settings.step ?? 1);
	const unit = (field.settings.unit as string) ?? '';
	const numValue = Number(value) || min;

	return (
		<div onBlur={onBlur}>
			{field.label && <div className='biz-form-field__label'>{field.label}</div>}
			<div className='biz-form-field__slider'>
				<input
					type='range'
					className='biz-form-field__slider-input'
					min={min}
					max={max}
					step={step}
					value={numValue}
					onChange={(e) => onChange(e.target.value)}
					disabled={disabled}
				/>
				{value !== '' && (
					<span className='biz-form-field__slider-value'>
						{numValue} {unit}
					</span>
				)}
			</div>
		</div>
	);
};

export default SliderField;
